import { searchConstants as C } from '../_constants';
import { searchService } from '../_services';
import { searchUtilities } from '../_utilities/search.utilities';
import { boxActions } from './box.actions';
import { notify } from '../../components/helpers/notification';

let seq = 0;
const PAGE_SIZE = 200; // the server's maximum page

// Every page of one search, in server order. Returns null as soon as a newer
// search or clear() supersedes run number `mine`, so no further pages are asked for.
async function fetchAllPages(q, kinds, mine) {
  const results = [];
  const seen = new Set();
  let total = 0;
  let offset = 0;
  do {
    const page = await searchService.search({ q, kinds, limit: PAGE_SIZE, offset });
    if (mine !== seq) return null;
    total = page.total;
    // rows can shift between pages if the index is re-pushed mid-run; keep ids unique
    page.results.forEach((r) => {
      if (!seen.has(r.item_id)) {
        seen.add(r.item_id);
        results.push(r);
      }
    });
    if (page.results.length === 0) break;
    offset += page.results.length;
  } while (offset < total);
  return { total, results };
}

// Like the tag filter: if the selected scan is no longer in the visible list,
// move the selection to the first visible one.
function selectFirstIfHidden(dispatch, getState) {
  const { box, stack, search } = getState();
  const visible = searchUtilities.visibleIds(
    box.origamis.allIds, stack.status.filter.length > 0, stack.status.filteredStack, search
  );
  if (visible.length > 0 && !visible.includes(box.status.selected)) {
    dispatch(boxActions.select(visible[0]));
  }
}

function run(q, kinds = []) {
  return async (dispatch, getState) => {
    seq += 1;
    const mine = seq;
    dispatch({ type: C.RUN_REQUEST, q, kinds, seq: mine });
    let succeeded = false;
    try {
      const all = await fetchAllPages(q, kinds, mine);
      if (!all) return; // superseded mid-paging: the newer run owns the state
      dispatch({ type: C.RUN_SUCCESS, seq: mine, total: all.total, results: all.results });
      succeeded = true;
    } catch (e) {
      const status = e?.response?.status;
      dispatch({ type: C.RUN_FAILURE, seq: mine, error: status === 503 ? 'unavailable' : 'failed' });
      if (mine !== seq) return; // superseded by a newer search or clear: stay quiet
      notify(status === 503 ? 'Search is unavailable right now' : 'Search failed');
    }
    if (succeeded && mine === seq) selectFirstIfHidden(dispatch, getState);
  };
}

function clear() {
  seq += 1;
  return { type: C.CLEAR };
}

function setKinds(kinds) {
  return (dispatch, getState) => {
    const { q } = getState().search;
    if (!q && kinds.length === 0) return dispatch(clear());
    return dispatch(run(q, kinds));
  };
}

// Sign out without leaving this user's results in the store for the next one.
function signOut(logout) {
  return (dispatch) => {
    dispatch(clear());
    return logout();
  };
}

export const searchActions = { run, clear, setKinds, signOut };
